import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: 'Sign Up Instantly',
      description: 'Create your free account in seconds and get immediate access to our powerful platform. No credit card required to start your journey.'
    },
    {
      number: 2,
      title: 'Choose a plan.',
      description: 'Depending on your sending needs you can start small or instantly scale up to 5000 emails a day.'
    },
    {
      number: 3,
      title: 'Pick a domain and start sending',
      description: 'You will instantly receive an unused, warmed up domain with a guaranteed 100% inbox hitrate, enter recepients, import your template and send.'
    }
  ];

  return (
    <section className="how-it-works-section" id='how-it-works'>
      <div className="how-it-works-content">
        <h2 className="how-it-works-headline">How It Works</h2>
        <p className="how-it-works-subheading">
          Get started in minutes with our simple 3-step process. No technical expertise required.
        </p>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={step.number} className="step-card">
              <div className="step-number">{step.number}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;